import React from 'react';

const SafetySection = ({ themeData }: any) => {
  return (
    <>
      {' '}
      <section className="safety-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span className="yellow-btn">
                  {themeData?.theme_3?.home?.section_10?.title}
                </span>
                <h2
                  style={{
                    color: `#${themeData?.theme_3?.home?.section_10?.h2color}`,
                  }}
                >
                  {themeData?.theme_3?.home?.section_10?.sub_heading_top}
                </h2>
                <p
                  style={{
                    color: `#${themeData?.theme_3?.home?.section_10?.paracolor}`,
                  }}
                >
                  {themeData?.theme_3?.home?.section_10?.mainparagraph}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="split-img">
                <img
                  src={themeData?.theme_3?.home?.section_10?.banner}
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="safety-content">
                <ul>
                  {themeData?.theme_3?.home?.section_10?.list_Section?.map(
                    (item: any, index: number) => {
                      return (
                        <>
                          <li key={index}>
                            <h3
                              style={{
                                color: `#${themeData?.theme_3?.home?.section_10?.h3color}`,
                              }}
                            >
                              {item.text}
                            </h3>
                            <p
                              style={{
                                color: `#${themeData?.theme_3?.home?.section_10?.paracolor}`,
                              }}
                            >
                              {item.paragraph}
                            </p>
                          </li>
                        </>
                      );
                    }
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt-4 d-none">
            <div className="col-md-3">
              <h2
                style={{
                  color: `#${themeData?.theme_3?.home?.section_10?.h2color}`,
                }}
              >
                {themeData?.theme_3?.home?.section_10?.card_section_title}{' '}
                {/* <span className="primary-text">Detergent Sheets.</span> */}
              </h2>
            </div>
            {themeData?.theme_3?.home?.section_10?.card_section?.map(
              (item: any, index: number) => {
                return (
                  <>
                    <div className="col-md-3">
                      <div
                        className="safety-list-card"
                        style={{
                          background: `#${item.card_bg_color}`,
                        }}
                      >
                        <h3
                          style={{
                            color: `#${themeData?.theme_3?.home?.section_10?.cardcolor}`,
                          }}
                        >
                          {item.card_text}
                        </h3>
                        <p
                          style={{
                            color: `#${themeData?.theme_3?.home?.section_10?.cardcolor}`,
                          }}
                        >
                          {item.card_paragraph}
                        </p>
                      </div>
                    </div>
                  </>
                );
              }
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SafetySection;
